import { z } from "zod";

const optionalTextParam = z.coerce.string().optional().catch(undefined);

const optionalTimestampParam = z.number().optional().catch(undefined);

export const botsHistorySearchSchema = z.object({
  page: z.coerce.number().int().positive().catch(1),
  title: optionalTextParam,
  bot_ids: optionalTextParam,
  types: optionalTextParam,
  trigger_types: optionalTextParam,
  created_at: optionalTextParam,
  created_at_gte: optionalTimestampParam,
  created_at_lte: optionalTimestampParam,
});

export const botsHistoryOrderSchema = z
  .record(z.string(), z.enum(["asc", "desc"]))
  .catch({});
